export default __webpack_public_path__ + "static/media/6t.be6e84c6.jpg";